<template>
  <div>
    <a-form class="custom-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="8">
          <a-form-item label="创建日期">
            <a-range-picker v-decorator="['created_at']" />
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="6">
          <a-form-item label="租户">
            <a-select
              @focus="fetchTenantAdminOptions"
              placeholder="请选择租户"
              v-decorator="['tenant_id']"
            >
              <a-select-option
                v-for="infoType in tenantAdminOptions"
                :key="infoType.id"
                :value="infoType.id"
              >
                {{ infoType.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6" :xxl="6">
          <a-form-item label="员工">
            <a-select
              v-decorator="['user_id']"
              placeholder="请选择员工"
              @focus="fetchUserOptions"
              @load="loadingUserOptions"
              allow-clear
            >
              <a-select-option
                v-for="user in userOptions"
                :key="user.id"
                :value="user.id"
              >
                {{ user.emp_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="4" :xxl="4">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { finSystemUserOptions } from '@/api/user'
import { findTenantAdminOptions } from '@/api/tenant'
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'

export default {
  name: 'SearchSmsRecord',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'sms_record_search' }),
      userOptions: [],
      tenantAdminOptions: [],
      loadingUserOptions: false
    }
  },
  methods: {
    fetchUserOptions() {
      this.loadingUserOptions = true
      finSystemUserOptions().then((res) => {
        if (res.code === 0) {
          this.userOptions = res.data
        }
        this.loadingUserOptions = false
      })
    },
    handleSearch(e) {
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        created_at_begin: formatRangeBeginDate(fieldsValue.created_at),
        created_at_end: formatRangeEndDate(fieldsValue.created_at)
      }
      this.$emit('submit', values)
    },
    fetchTenantAdminOptions() {
      findTenantAdminOptions().then((res) => {
        if (res.code === 0) {
          this.tenantAdminOptions = res.data
        }
      })
    },
    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>

